//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import WhPackCreate from '@/views/Warehouse/WhPack/WhPackCreate'
import WhPackList from '@/views/Warehouse/WhPack/WhPackList'
import WhPackUpdate from '@/views/Warehouse/WhPack/WhPackUpdate'

//
export default {
  path: 'packs',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'wh-pack-list',
      component: WhPackList,
    },
    {
      path: 'create',
      name: 'wh-pack-create',
      component: WhPackCreate,
      meta: {
        title: 'Crear packs'
      },
    },
    {
      path: ':id',
      name: 'wh-pack-update',
      component: WhPackUpdate,
      meta: {
        title: 'Editar packs'
      },
    },
  ],
  meta: {
    title: 'Packs'
  },
}
